/* eslint no-unused-expressions: 0 */
import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { GAfireEvent } from "./Tracking";
import xIconImage from '../images/x-icon.svg';
import hamburgerOpenIcon from '../images/hamburger--open.svg';
import { isEs } from "../libs/lang";

import {fireTag} from '../libs/analytics';

/*
* Mobile Nav Toggling
*/
let toggledOpen = false;

const toggleDOMariaHidden = (hide = true) => {
	const elemsOutsideNav = document.querySelectorAll('main, footer');
	elemsOutsideNav.forEach(elem => {
		elem.setAttribute('aria-hidden', `${hide}`);
	});
}

const NavMobile = ({activePage, toggleInert}) => {

	const mobileNav = useRef(null);
	// eslint-disable-next-line func-names
	const toggleNav = (e, focusHamburger = false) => {

		e = e || window.event;
		const hamburger = document.getElementById('hamburger');
		const menu = document.getElementsByClassName('mobile-nav')[0];
		const wfLogo = document.getElementById('wf-logo');
		const xIcon = document.getElementById('x-icon');
		const footer = document.getElementsByTagName('footer')[0];

		if (e.type === 'click' || e.key === 'Enter') {
			const isMenuClosed = menu.getAttribute('aria-hidden') === 'true';

			toggledOpen = !toggledOpen;
			toggleInert();

			menu.classList.toggle('open');

			const mobileLinks = document.getElementsByClassName('mobile-nav--link');

			if (isMenuClosed) {
				toggleDOMariaHidden();

				menu.setAttribute('aria-hidden', 'false');
				menu.setAttribute('tabindex', '0');
				menu.style.height = '100vh';

				[...mobileLinks].forEach(link => {
					link.setAttribute('tabindex', '0');
				});

				xIcon.setAttribute('tabindex', '0');

				hamburger.setAttribute('tabindex', '-1');
				hamburger.setAttribute('aria-hidden', 'true');

				wfLogo.setAttribute('tabindex', '-1');
				wfLogo.setAttribute('aria-hidden', 'true');

				if (document.getElementsByClassName('content').length) document.getElementsByClassName('content')[0].inert = true;

				footer.inert = true;

				window.setTimeout(() => {
						xIcon.focus();
				}, 500)
			}
			else {
				toggleDOMariaHidden(false);
				menu.setAttribute('aria-hidden', 'true');
				menu.setAttribute('tabindex', '-1');

				[...mobileLinks].forEach(link => {
					link.setAttribute('tabindex', '-1');
				});

				xIcon.setAttribute('tabindex', '-1');

				hamburger.setAttribute('tabindex', '0');
				hamburger.setAttribute('aria-hidden', 'false');

				wfLogo.setAttribute('tabindex', '0');
				wfLogo.setAttribute('aria-hidden', 'false');

				if (document.getElementsByClassName('content').length) document.getElementsByClassName('content')[0].inert = false;

				footer.inert = false;

				if (focusHamburger) {
					window.setTimeout(() => {
						hamburger.focus();
					}, 500)
				}
			}
		}

	}

	const trapTabKey = () => {
		const allLinks = document.querySelectorAll('.mobile-nav button#x-icon, a.mobile-nav--link')
		const lastLink = allLinks[allLinks.length - 1];
		const firstLink = allLinks[0];

		mobileNav.current.addEventListener('keydown', (k) => {
			if (k.keyCode === 9) {
				if (k.shiftKey) {
					if (document.activeElement === firstLink) {
						k.preventDefault();
						lastLink.focus();
					}
				}
				else {
					if (document.activeElement === lastLink) {
						k.preventDefault();
						firstLink.focus();
					}
				}
			}
		})
	}

	useEffect(() => {
		trapTabKey();
	}, [mobileNav]);

if(isEs()){
 return (
	<>
	<button
	  id="hamburger"
	  className="hamburger nav--mobile"
	  onClick={(e) => {
		//GAfireEvent('G5');
		fireTag('open-hamburger');
		toggleNav(e);
	  }}
	  type="button"
	>
	  <img alt="hamburger nav" src={hamburgerOpenIcon} height="16" width="28"/>
	</button>
	<div className="mobile-nav" aria-hidden="true" ref={mobileNav} role="dialog" tabIndex="-1">
	  {/* eslint-disable-next-line react/button-has-type */}
	  <button
		id="x-icon"
		tabIndex="-1"
		aria-label="Cierra el menu de navegacion movil."
		onClick={(e) => {
		  e.preventDefault();
		  //GAfireEvent('G6');
		  fireTag('close-hamburger');
		  toggleNav(e, true);
		}}
		onKeyPress={(e) => {
		  e.preventDefault();
		  //GAfireEvent('G6');
		  toggleNav(e, true);
		}}
	  >
		<img src={xIconImage} alt="Icono de cierra del menu movil." />
	  </button>
	  <ul>
		<Link
		  to="/" className={`mobile-nav--link${activePage === "home" ? " active" : ""}`}
		  tabIndex="-1"
		  onClick={() => {
			window.scrollTo(0, 0);
			fireTag("G2");
			//GAfireEvent('G2', { label: 'our priorities' })
		  }}
		>Nuestras prioridades</Link>
		<Link
		  to="/sustainability/"
		  className={`mobile-nav--link${activePage === "sustainability" ? " active" : ""}`}
		  tabIndex="-1"
		  onClick={(e) => {
			window.scrollTo(0, 0);
			fireTag("G3");
			//GAfireEvent('G2', { label: 'institute for sustainable finance' });
		  }}
		>Instituto de Finanzas Sostenibles (en inglés)</Link>
		{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
	  </ul>
	  <div>
		<ul className="secondary">
		<Link
		  to=""
		  className="mobile-nav--link"
		  tabIndex="-1"
		  lang="en"
		  onClick={(e) => {
			e.preventDefault();
			//GAfireEvent('G6');
			toggleNav(e, true);
			window.location.href = window.location.href.replace('/es','');
		}}>English</Link>
		<Link
		  to=""
		  className="mobile-nav--link"
		  tabIndex="-1"
		  onClick={(e) => {
			e.preventDefault();
			//GAfireEvent('G6');
			toggleNav(e, true);
		}}>Cerca</Link>
		</ul>
	  </div>
	</div>
  </>
 )
} else {
	return (
		<>
			<button
				id="hamburger"
				className="hamburger nav--mobile"
				onClick={(e) => {
					//GAfireEvent('G5');
					console.log('click')
					fireTag('open-hamburger');
					toggleNav(e);
				}}
				type="button"
			>
				<img alt="hamburger nav" src={hamburgerOpenIcon} height="16" width="28"/>
			</button>
			<div className="mobile-nav" aria-hidden="true" ref={mobileNav} role="dialog"  tabIndex="-1">
				{/* eslint-disable-next-line react/button-has-type */}
				<button
					id="x-icon"
					tabIndex="-1"
					aria-label="Closes the mobile navigation menu."
					onClick={(e) => {
						//GAfireEvent('G6');
						fireTag('close-hamburger')
						toggleNav(e, true);
					}}
					onKeyPress={(e) => {
						e.preventDefault();
						//GAfireEvent('G6');
						toggleNav(e, true);
					}}
				>
					<img src={xIconImage} alt="Mobile menu close icon."/>
				</button>
				<ul>
					<Link
						to="/" className={`mobile-nav--link${activePage === "home" ? " active" : ""}`}
						tabIndex="-1"
						onClick={() => {
							window.scrollTo(0, 0);
							fireTag('G2');
							//GAfireEvent('G2', {label: 'our priorities'})
						}}
					>Our Priorities</Link>
					<Link
						to="/sustainability/"
						className={`mobile-nav--link${(activePage === "sustainability" || activePage === "articles") ? " active" : ""}`}
						tabIndex="-1"
						onClick={(e) => {
							e.preventDefault();
							window.scrollTo(0, 0);
							fireTag('G3');
							//GAfireEvent('G2', {label: 'institute for sustainable finance'});
							//# rename
							window.location.href = window.location.origin + `${process.env.PUBLIC_URL}/sustainability`;
						}}
					>Institute for Sustainable Finance</Link>
				</ul>
				<div>
					<ul className="secondary">

						{(activePage === 'home' || activePage === 'housing') && (
							// eslint-disable-next-line jsx-a11y/anchor-is-valid
							<Link
								to=""
								className="mobile-nav--link"
								tabIndex="-1"
								onClick={(e) => {
									e.preventDefault();
									//GAfireEvent('G6');
									toggleNav(e, true);
									window.location.href = window.location.href.replace('/impact/', '/es/impact/');
								}}>Español</Link>
						)}
						{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
						<Link
							to=""
							className="mobile-nav--link"
							tabIndex="-1"
							onClick={(e) => {
								e.preventDefault();
								//GAfireEvent('G6');
								toggleNav(e, true);
							}}>Close</Link>
					</ul>
				</div>
			</div>
		</>
	)
}
};


export default NavMobile;
